import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Resources.css';

const Resources = () => {
  const [activeTab, setActiveTab] = useState('news');

  // To add a new news post:
  // 1. Add an entry to this array with the details
  const newsPosts = [
    {
      id: 1,
      title: 'VerTech Announces Expanded Business Intelligence Services',
      excerpt: 'We are excited to announce the expansion of our Business Intelligence practice, offering enhanced dashboard and analytics capabilities to help businesses make data-driven decisions.',
      date: '2025-01-15',
      author: 'VerTech Team',
      category: 'Company News'
    },
    {
      id: 2,
      title: 'New Partnership with Leading CRM Provider',
      excerpt: 'VerTech has formed a strategic partnership to bring advanced CRM implementation services to our clients, ensuring seamless integration and adoption.',
      date: '2024-12-10',
      author: 'VerTech Team',
      category: 'Partnerships'
    },
    {
      id: 3,
      title: 'Cybersecurity Best Practices for 2025',
      excerpt: 'As cyber threats evolve, staying ahead of security challenges is critical. Learn about the latest cybersecurity strategies and how to protect your business.',
      date: '2024-11-28',
      author: 'Security Team',
      category: 'Technology Insights'
    }
  ];

  // To add a new whitepaper:
  // 1. Drop the PDF file in public/whitepapers/ folder
  // 2. Add an entry to this array with the details
  const whitepapers = [
    {
      id: 1,
      title: 'The Hidden Costs of “Good Enough” IT Infrastructure',
      description: 'A professional insight exploring how “good enough” IT infrastructure silently drains profits, reduces efficiency, and exposes businesses to costly risks..',
      date: '2025-11-10',
      filename: 'Hidden_Costs_of_Good_Enough_IT_Infrastructure_Vertech.pdf',
      category: 'Technology'
    },
    {
      id: 2,
      title: 'CRM Implementation Best Practices',
      description: 'Learn the key steps to successful CRM implementation, from planning to post-launch optimization.',
      date: '2024-11-20',
      filename: 'crm-best-practices.pdf',
      category: 'Software'
    },
    {
      id: 3,
      title: 'Business Intelligence Dashboard Design',
      description: 'Discover how to design effective dashboards that drive actionable insights and business decisions.',
      date: '2024-10-05',
      filename: 'bi-dashboard-design.pdf',
      category: 'Intelligence'
    }
  ];

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <div className="resources-page">
      <section className="resources-hero">
        <div className="resources-hero-container">
          <h1 className="resources-hero-title">News & Resources</h1>
          <p className="resources-hero-description">
            Stay informed with the latest news, insights, and resources from VerTech
          </p>
        </div>
      </section>

      <section className="resources-content">
        <div className="resources-container">
          <div className="resources-tabs">
            <button 
              className={`resources-tab ${activeTab === 'news' ? 'active' : ''}`}
              onClick={() => setActiveTab('news')}
            >
              News & Updates
            </button>
            <button 
              className={`resources-tab ${activeTab === 'whitepapers' ? 'active' : ''}`}
              onClick={() => setActiveTab('whitepapers')}
            >
              Whitepapers
            </button>
          </div>

          {activeTab === 'news' && (
            <div className="news-grid">
              {newsPosts.map((post) => (
                <div key={post.id} className="news-card">
                  <div className="news-category">{post.category}</div>
                  <h3 className="news-title">{post.title}</h3>
                  <div className="news-meta">
                    <span className="news-author">{post.author}</span>
                    <span className="news-date">{formatDate(post.date)}</span>
                  </div>
                  <p className="news-excerpt">{post.excerpt}</p>
                </div>
              ))}
              {newsPosts.length === 0 && (
                <div className="resources-empty">
                  <p>No news posts available at this time. Check back soon!</p>
                </div>
              )}
            </div>
          )}

          {activeTab === 'whitepapers' && (
            <div className="resources-grid">
              {whitepapers.map((paper) => (
                <div key={paper.id} className="whitepaper-card">
                  <div className="whitepaper-category">{paper.category}</div>
                  <h3 className="whitepaper-title">{paper.title}</h3>
                  <p className="whitepaper-date">{formatDate(paper.date)}</p>
                  <p className="whitepaper-description">{paper.description}</p>
                  <a 
                    href={`/whitepapers/${paper.filename}`} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="btn-whitepaper-download"
                  >
                    Download PDF
                  </a>
                </div>
              ))}
              {whitepapers.length === 0 && (
                <div className="resources-empty">
                  <p>No whitepapers available at this time. Check back soon!</p>
                </div>
              )}
            </div>
          )}
        </div>
      </section>

      <section className="resources-cta">
        <div className="resources-container">
          <h2 className="resources-cta-title">Need Expert Guidance?</h2>
          <p className="resources-cta-description">
            Our team is ready to help you navigate your technology challenges
          </p>
          <Link to="/contact" className="btn-resources-primary">Contact Us</Link>
        </div>
      </section>
    </div>
  );
};

export default Resources;
